import { render, staticRenderFns } from "./IndexByCategory.vue?vue&type=template&id=5f17805e&scoped=true&"
import script from "./IndexByCategory.vue?vue&type=script&lang=js&"
export * from "./IndexByCategory.vue?vue&type=script&lang=js&"
import style0 from "./IndexByCategory.vue?vue&type=style&index=0&id=5f17805e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f17805e",
  null
  
)

export default component.exports